// extracted by mini-css-extract-plugin
module.exports = {"container":"Kr","topReviewHeading":"Lr","criticalReview":"Mr","favorableReview":"Nr","vsSeparator":"Or"};